var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPdfLoading)?_c('v-progress-linear',{attrs:{"id":"myProgress","color":"#4dccc4","height":"25"},model:{value:(_vm.percent),callback:function ($$v) {_vm.percent=$$v},expression:"percent"}},[_c('strong',[_vm._v("Generating...")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }